<div class="fp-dialog">
  <h3 mat-dialog-title>Enrolar huella en reloj</h3>
  <mat-dialog-content class="fp-dialog__content">
    <div class="fp-dialog__intro">
      <div class="fp-dialog__employee">
        <span class="fp-dialog__employee-number">{{ data.employeeNumber }}</span>
        <h5>{{ data.employeeName }}</h5>
      </div>

      <div class="fp-dialog__selection"
           [class.fp-dialog__selection--empty]="!selectedFinger">
        <span class="fp-dialog__selection-label">Dedo seleccionado</span>
        @if (selectedFinger) {
        <strong>{{ getFingerLabel(selectedFinger) }}</strong>
        <small>ID {{ selectedFinger.id }}</small>
        } @else {
        <strong>Sin selección</strong>
        <small>Elige un dedo para continuar</small>
        }
      </div>
    </div>

    <mat-form-field subscriptSizing="dynamic" appearance="outline"
                    class="fp-dialog__device-field mt-0 mb-0 pb-0">
      <mat-label>Reloj</mat-label>
      <mat-select [(ngModel)]="selectedDeviceId">
        @for (device of data.devices; track device.deviceId) {
        <mat-option [value]="device.deviceId">
          {{ device.name }}@if (device.serial) { ({{ device.serial }}) }
        </mat-option>
        }
      </mat-select>
    </mat-form-field>

    @if (isLoadingBiometrics) {
    <div class="fp-dialog__hint">Consultando huellas ya registradas del empleado...</div>
    } @else if (enrolledFingerIds.size) {
    <div class="fp-dialog__hint">Los dedos ya enrolados se muestran bloqueados para evitar duplicados.</div>
    }

    <div class="fp-hands mt-0 p-0">
      <section class="fp-hand"
               [class.fp-hand--expanded]="expandedHand === 'left'">
        <button type="button"
                class="fp-hand-header"
                (click)="toggleHand('left')">
          <div class="fp-hand-title">
            <mat-icon>back_hand</mat-icon>
            <div>
              <strong>Mano izquierda</strong>
              <small>ID 0 meñique · ID 4 pulgar</small>
            </div>
          </div>

          <div class="fp-hand-meta">
            <span class="fp-hand-badge">IDs 0-4</span>
            <span class="fp-hand-hint">Del meñique al pulgar</span>
          </div>

          <mat-icon class="fp-hand-header__chevron">expand_more</mat-icon>
        </button>

        <div class="fp-hand-body">
          <div class="fp-hand-visual fp-hand-visual--left">
            @for (finger of leftFingers; track finger.id) {
            <button type="button"
                    class="fp-hotspot"
                    [ngClass]="getFingerPositionClass(finger)"
                    [class.fp-hotspot--selected]="selectedFingerId === finger.id"
                    [class.fp-hotspot--disabled]="isFingerDisabled(finger.id)"
                    [attr.aria-label]="getFingerLabel(finger) + ' ID ' + finger.id"
                    [attr.title]="getFingerLabel(finger) + ' · ID ' + finger.id + (isFingerDisabled(finger.id) ? ' · Ya enrolado' : '')"
                    [disabled]="isFingerDisabled(finger.id)"
                    (click)="selectFinger(finger.id)">
              <span class="fp-hotspot__id">ID {{ finger.id }}</span>
              <span class="fp-hotspot__target">
                <mat-icon>fingerprint</mat-icon>
              </span>
            </button>
            }
          </div>
        </div>
      </section>

      <section class="fp-hand"
               [class.fp-hand--expanded]="expandedHand === 'right'">
        <button type="button"
                class="fp-hand-header"
                (click)="toggleHand('right')">
          <div class="fp-hand-title">
            <mat-icon>back_hand</mat-icon>
            <div>
              <strong>Mano derecha</strong>
              <small>ID 5 pulgar · ID 9 meñique</small>
            </div>
          </div>

          <div class="fp-hand-meta">
            <span class="fp-hand-badge">IDs 5-9</span>
            <span class="fp-hand-hint">Del pulgar al meñique</span>
          </div>

          <mat-icon class="fp-hand-header__chevron">expand_more</mat-icon>
        </button>

        <div class="fp-hand-body">
          <div class="fp-hand-visual fp-hand-visual--right">
            @for (finger of rightFingers; track finger.id) {
            <button type="button"
                    class="fp-hotspot"
                    [ngClass]="getFingerPositionClass(finger)"
                    [class.fp-hotspot--selected]="selectedFingerId === finger.id"
                    [class.fp-hotspot--disabled]="isFingerDisabled(finger.id)"
                    [attr.aria-label]="getFingerLabel(finger) + ' ID ' + finger.id"
                    [attr.title]="getFingerLabel(finger) + ' · ID ' + finger.id + (isFingerDisabled(finger.id) ? ' · Ya enrolado' : '')"
                    [disabled]="isFingerDisabled(finger.id)"
                    (click)="selectFinger(finger.id)">
              <span class="fp-hotspot__id">ID {{ finger.id }}</span>
              <span class="fp-hotspot__target">
                <mat-icon>fingerprint</mat-icon>
              </span>
            </button>
            }
          </div>
        </div>
      </section>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end"
                      class="fp-dialog__actions">
    <button mat-stroked-button
            type="button"
            (click)="close()">Cancelar</button>
    <button mat-flat-button
            color="primary"
            type="button"
            [disabled]="!canSubmit"
            (click)="submit()">
      Enviar enrolamiento
    </button>
  </mat-dialog-actions>
</div>